module.exports = __webpack_public_path__ + "static/soc2-1aca0b2dd7e2f8330455aabff24bf4c9.png";